import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'internal-services' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
